// extracted by mini-css-extract-plugin
module.exports = {"widgetPlaceholder":"WidgetPlaceholder_widgetPlaceholder__1LsGO"};